import React, { useState } from 'react';
import {
  LayoutDashboard,
  MapPin,
  FolderOpen,
  UserRound,
  Users,
  Building,
  FileText,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Image
} from 'lucide-react';
import { MdBusiness, MdList, MdSlideshow } from 'react-icons/md';
import { SlSpeech } from "react-icons/sl";
import { MdOutlineNotificationsActive } from "react-icons/md";

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
{ id: 'sliders', label: 'Sliders', icon: <Image  size={20} /> },

{ id: 'properties-menu', label: 'Properties Menu', icon: <FolderOpen size={20} /> },

{ id: 'properties', label: 'Properties', icon: <Building size={20} /> },

  {
    id: 'zone-creation',
    label: 'Highway Master',
    icon: <MapPin size={20} />,
    // children: [{ id: 'zone-creation', label: 'Zone Creation' }]
  },
  {
    id: 'project-master',
    label: 'Property Master',
    icon: <FolderOpen size={20} />,
    children: [
       { id: 'layoutApprovals', label: 'LayoutApprovals' },
      { id: 'project-creation', label: 'Property Creation' },
            { id: 'property-owner-creation', label: 'Property Owner Creation' }
    
    ]
  },
  //   {
  //   id: 'property-owner',
  //   label: 'Property Owner',
  //   icon: <Building size={20} />,
  //   children: [{ id: 'property-owner-creation', label: 'Property Owner Creation' }]
  // },

  // {
  //   id: 'project-head-creation',
  //   label: 'Property Head',
  //   icon: <UserRound size={20} />,
  //   // children: [{ id: 'project-head-creation', label: 'Property Head Creation' }]
  // },
  {
    id: 'associate-creation',
    label: 'Associate',
    icon: <Users size={20} />,
    // children: [{ id: 'associate-creation', label: 'Associate Creation' }]
  },
  {
    id:'investor-leads',
    label:'Investor Leads',
      icon: <Users size={20} />
  },
   {
    id: 'greetings-creation',
    label: 'Greetings',
    icon: <SlSpeech size={20} />,
    // children: [{ id: 'associate-creation', label: 'Associate Creation' }]
  },
    {
    id: 'enabled-location',
    label: 'Geo-LocationPermission',
    icon: <SlSpeech size={20} />,
    // children: [{ id: 'associate-creation', label: 'Associate Creation' }]
  },
    {
    id: 'notifications-creation',
    label: 'Notifications',
    icon: <MdOutlineNotificationsActive size={20} />,
    // children: [{ id: 'associate-creation', label: 'Associate Creation' }]
  },

    // {
    // id:'investors',
    // label:'Investor',
    //   icon: <Users size={20} />,
    //    children: [
    //       { id: 'investor', label: 'Investor Approve' },
    //     { id: 'investor-leads', label: 'Investor Lead' }
    //    ]   },

  { id: 'reports', label: 'Reports', icon: <FileText size={20} /> },
  { id: 'settings', label: 'Settings', icon: <Settings size={20} /> }
];

const AdminSidebar = ({ activePage, onPageChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedItems, setExpandedItems] = useState(['zone-master']);

  const toggleExpand = (id) => {
    setExpandedItems((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleLogout = () => {
    if (window.confirm('Do you want to return to the main website?')) {
      window.location.href = '/';
    }
  };

  return (
    <aside
      style={{
        width: isCollapsed ? 80 : 260,
        height: '100vh', // ensure full viewport height
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto', // allow scrolling for entire sidebar
        backgroundColor: '#ffffff',
        borderRight: '1px solid black',
        transition: 'width 0.3s'
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid rgba(74,140,124,0.4)'
        }}
      >
        {!isCollapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Building size={24} color="#7f4070" />
            <span style={{ fontWeight: '600', color: '#7f4070' }}>
              Admin Panel
            </span>
          </div>
        )}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            padding: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            borderRadius: 8
          }}
        >
          {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
        </button>
      </div>

      {/* Menu */}
      <nav style={{ flex: 1, overflowY: 'auto', paddingTop: 8 }}>
        {menuItems.map((item) => (
          <div key={item.id}>
            <button
              // onClick={() =>
              //   item.children ? toggleExpand(item.id) : onPageChange(item.id)
              // }
              onClick={() => {
  if (item.children && item.children.length > 0) {
    toggleExpand(item.id);
  } else {
    onPageChange(item.id);
  }
}}

              style={{
                width: '100%',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                background:
                  activePage === item.id ? 'rgba(127,64,112,0.2)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRight:
                  activePage === item.id
                    ? '4px solid #7f4070'
                    : 'none'
              }}
            >
              <span style={{ color: activePage === item.id ? '#7f4070' : '#000' }}>
                {item.icon}
              </span>
              {!isCollapsed && <span>{item.label}</span>}
            </button>

            {/* Sub menu */}
            {item.children &&
              !isCollapsed &&
              expandedItems.includes(item.id) && (
                <div style={{ backgroundColor: 'rgba(127,64,112,0.05)' }}>
                  {item.children.map((child) => (
                    <button
                      key={child.id}
                      onClick={() => onPageChange(child.id)}
                      style={{
                        width: '100%',
                        padding: '8px 48px',
                        textAlign: 'left',
                        background:
                          activePage === child.id
                            ? 'rgba(127,64,112,0.2)'
                            : 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        color:
                          activePage === child.id ? '#7f4070' : '#000'
                      }}
                    >
                      {child.label}
                    </button>
                  ))}
                </div>
              )}
          </div>
        ))}
      </nav>

      {/* Logout */}
      <button
        onClick={handleLogout}
        style={{
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          borderTop: '1px solid rgba(74,140,124,0.4)',
          background: 'transparent',
          cursor: 'pointer'
        }}
      >
        <LogOut size={20} color="red" />
        {!isCollapsed && <span>Logout</span>}
      </button>
    </aside>
  );
};

export default AdminSidebar;
